import { getInstanceMaintenanceHistory } from "@/apis";

export const MaintenanceDataProvider = {
  getList: async ({ resource, pagination, filters, sorters, meta }) => {
    const response = await getInstanceMaintenanceHistory(meta.id, {current:pagination.current, pageSize:pagination.pageSize, filters, sorters});
    if (response.status === "Error") {
      return {
        data: [],
        total: 0
      }
    } else {
      const data = response.items || response;
      if(data) {
        return {
          data,
          total: data.length
        };
      } else {
        return {
          data: [],
          total: 0
        }
      }
    }
  },  
};
